/**
 * Permission constants for the Terra application
 * Use these constants instead of hardcoded permission strings
 */

export const PERMISSIONS = {
	PROJECT: {
		VIEW: "View.Project",
		CREATE: "Create.Project",
		EDIT: "Edit.Project",
		DELETE: "Delete.Project",
	},
	WELL: {
		VIEW: "View.Well",
		CREATE: "Create.Well",
		EDIT: "Edit.Well",
		DELETE: "Delete.Well",
	},
	OPERATION: {
		VIEW: "View.Operation",
		CREATE: "Create.Operation",
		EDIT: "Edit.Operation",
		OPERATIONAL_UPDATE: "Operational Update.Operation",
		DELETE: "Delete.Operation",
	},
} as const;

export type PermissionType =
	| (typeof PERMISSIONS.PROJECT)[keyof typeof PERMISSIONS.PROJECT]
	| (typeof PERMISSIONS.WELL)[keyof typeof PERMISSIONS.WELL]
	| (typeof PERMISSIONS.OPERATION)[keyof typeof PERMISSIONS.OPERATION];

// Role keys used in the application
export const ROLE_KEYS = {
	TENANT_ADMIN: "tenant_admin",
	TENANT_MEMBER: "tenant_member",
	PROJECT_MANAGER: "project_manager",
	TEAM_MEMBER: "team_member",
	GENERAL_MEMBER: "general_member",
	WELL_EXAMINER: "well_examiner",
} as const;

export type RoleKeyType = (typeof ROLE_KEYS)[keyof typeof ROLE_KEYS];
